import React, { useState, useEffect } from "react";
import TypingEffect from "../HomePage/VideoComponent/TypingEffect";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedinIn,
  faGithub,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

function Footer() {
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsHomePage(true);
    } else {
      setIsHomePage(false);
    }
  }, [location]);

  return (
    <>
      <footer
        id="footer"
        dir="rtl"
        className={`${
          isHomePage ? "" : "bg-black"
        } text-light text-center py-5`}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-12 m-auto">
              <div className="mb-4" style={{ fontSize: "30px" }}>
                <TypingEffect text="יצירת קשר" />
              </div>

              <ul className="d-flex justify-content-around list-inline social-icons p-0">
                <li>
                  <a
                    href="https://www.linkedin.com/in/nati-grossman"
                    data-tooltip="LinkedIn"
                    aria-label="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faLinkedinIn}
                      size="2x"
                      className="icon-footer p-1"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:natngr96@gmail.com"
                    data-tooltip="Email"
                    aria-label="Email"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faGoogle}
                      size="2x"
                      className="icon-footer p-1"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/nati-grossman"
                    data-tooltip="GitHub"
                    aria-label="GitHub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faGithub}
                      size="2x"
                      className="icon-footer p-1"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer row mt-3">
            <div className="col text-center responsive-footer n-text-light">
              <p>&copy; {new Date().getFullYear()}</p>
              <p>
                אשמח לקבל את המשוב שלכם! אם יש לכם הצעות או מצאתם בעיה, אנא
                הודיעו לי.
              </p>
              <p>
                פותח ומנוהל על ידי{" "}
                <span style={{ fontSize: "25px" }}>
                  <TypingEffect text="נתי גרוסמן" />
                </span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
